"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(base, subtitle) {
    var subtitleText = base.subtitle;
    var options = { text: subtitleText, align: 'center' };
    if (subtitle) {
        options = __assign(__assign({}, options), subtitle.props);
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=subtitleOptions.js.map